import { useActiveUserContext } from "contexts/ActiveUserContext";
import _ from "lodash"
export default function   useEnvironmentVariables(variableName)  {
    const activeUserContext = useActiveUserContext();
    const reactAppValues = activeUserContext.sessionData.reactAppValues;
    return _.get(reactAppValues, variableName, "");
};